import axios from '@utils/axios';
import { Response } from '@shared/model/type/response.type';

export function fetchContractList(data: { page: number; pageSize: number; contractStatus: number[] }) {
    return axios.post('/v1/contract/list', {
        ...data,
    }) as Promise<Response>;
}
